const createMessage = (id, text, additionalInfo, type, dismissAfter) => {
  return {
    id,
    text,
    additionalInfo,
    type,
    dismissAfter,
  };
};

export default createMessage;
